module.exports = __webpack_public_path__ + "img/drive.36e81163.png";